import { render, staticRenderFns } from "./MultiSelectionSpecificity.vue?vue&type=template&id=edaba656&"
import script from "./MultiSelectionSpecificity.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectionSpecificity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports